import { createActionConst } from '../../../utils/action.utils';

const VTO_PAGE_NAMESPACE = 'VTO_PAGE';

export const VTO_MEETING_PAGE = createActionConst(VTO_PAGE_NAMESPACE, 'VTO_MEETING_PAGE');
